import { Box, Button, Chip, Skeleton, Stack, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import ListingFeatures from "./listing-features";
import ChooseDeliverType from "./delivery-type";
import ListingOwner from "./listing-owner";
import RulesPolicyDoc from "./rules-policy-doc";
import { ROUTES } from "constants/routes";
import { useNavigate } from "react-router-dom";
import { addItemToCart, fetchCart } from "slices/cartReducer";
import { useEffect, useState } from "react";
import { checkAddToCartAllow, checkHasAddedToCart } from "utils/cart.util";
import { handleSnackBar } from "slices/global";
import { getAuthUserId } from "utils/auth.util";

const CustomChip = ({ label, val }: any) => (
  <Chip
    sx={{ background: "#F4F4F4" }}
    label={
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1.5}
      >
        <Typography
          sx={{
            fontSize: "13px",
            color: "#323232",
            fontWeight: 500,
            lineHeight: "16px",
          }}
        >
          {label} :
        </Typography>
        <Typography
          sx={{
            fontSize: "13px",
            color: "#323232",
            fontWeight: 500,
            lineHeight: "16px",
          }}
        >
          {val}
        </Typography>
      </Stack>
    }
  />
);

const ListingDetails = () => {
  const { listingDetails, loadingDetails }: any = useAppSelector(
    (state) => state.searchListingReducer
  );
  const { authReducer, cartReducer }: any = useAppSelector((state) => state);
  const listingFeatures = listingDetails?.listing_features?.[0];
  const { listing_type, user } = listingDetails;

  const approvalPolicy = user?.user_profile_configs?.[0]?.approval_policy_type;
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const [delvType, setDelvType] = useState<number | null>(null);
  const [showWholeDesc, setShowWholeDesc] = useState(false);

  // const checkedItem: any = cartReducer?.items?.filter(
  //   (s: any) => s.listing_id === listingDetails.id
  // );
  const offerDelPickup =
    listingDetails?.user?.user_profile_configs?.[0]?.offer_delv_pickup;
  const isAddedToCart = checkHasAddedToCart(
    listingDetails,
    cartReducer?.items ?? []
  );

  useEffect(() => {
    if (authReducer.isLoggedIn) {
      dispatch(fetchCart({ query: "" }));
    }
    setDelvType(offerDelPickup);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offerDelPickup]);

  const addTocart = () => {
    if (!authReducer.isLoggedIn) navigation(`${ROUTES.SIGNIN}`);

    // call API
    if (authReducer.isLoggedIn) {
      dispatch(
        addItemToCart({ id: listingDetails.id, deliveryType: Number(delvType) })
      );
    } else {
      navigation(`${ROUTES.SIGNIN}`);
    }
  };

  // useEffect(() => {
  //   // const { items = [] } = cartReducer;
  //   if (cartReducer?.items.length > 0) {
  //     if (checkedItem.length > 0) {
  //       setDelvType(checkedItem?.[0]?.delivery_type ?? null);
  //     }
  //   }
  // }, [cartReducer, listingDetails.id, checkedItem]);

  return (
    <Box sx={{ pr: { md: "4%", lg: "4%", xl: "4%", sm: "0%", xs: "0%" } }}>
      <Box
        sx={{
          pl: { md: "2%", lg: "2%", xl: "2%", sm: "4%", xs: "4%" },
          py: "20px",
        }}
      >
        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 600,
            lineHeight: "31px",
            color: "#323232",
          }}
        >
          {!loadingDetails ? (
            `${listingDetails?.listing_name}`
          ) : (
            <Skeleton
              variant="rectangular"
              sx={{
                height: "30px",
                width: "100%",
              }}
            />
          )}
        </Typography>

        {/* <Box
          sx={{
            height: "32px",
            width: "112px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            background: "#F1B724",
            borderRadius: "20px",
            gap: "5px",

            my: "10px",
          }}
        >
          <Typography
            sx={{
              color: "#FFF",
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            Rating:
          </Typography>
          <img
            alt=""
            src="/assets/img/icons/star.svg"
            width="16px"
            height="16px"
          />
          <Typography
            sx={{
              color: "#FFF",
              fontSize: "14px",
              fontWeight: 500,
            }}
          >
            4.8
          </Typography>
        </Box> */}

        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "24px",
            color: "#A2A2A2",

            mb: "15px",
            display: {
              md: "none",
              lg: "none",
              xl: "none",
              sm: "block",
              xs: "block",
            },
          }}
        >
          {!loadingDetails ? (
            <>
              {listingDetails?.listing_description?.length}
              {listingDetails?.listing_description?.length > 150 &&
              !showWholeDesc
                ? `${listingDetails?.listing_description.slice(0, 150)}...`
                : listingDetails?.listing_description}
              {listingDetails?.listing_description?.length > 150 && (
                <Typography
                  onClick={() => setShowWholeDesc(!showWholeDesc)}
                  component="span"
                  sx={{
                    color: "#307AFF",
                    fontSize: "15px",
                    fontWeight: "400",
                    cursor: "pointer",
                  }}
                >
                  {showWholeDesc ? `Read Less` : `Read More`}
                </Typography>
              )}
            </>
          ) : (
            <Skeleton
              variant="rectangular"
              sx={{
                height: "30px",
                width: "100%",
              }}
            />
          )}
        </Typography>

        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "24px",
            color: "#A2A2A2",

            mb: "15px",
            display: {
              md: "block",
              lg: "block",
              xl: "block",
              sm: "none",
              xs: "none",
            },
          }}
        >
          {!loadingDetails ? (
            <>
              {listingDetails?.listing_description?.length}
              {listingDetails?.listing_description?.length > 500 &&
              !showWholeDesc
                ? `${listingDetails?.listing_description.slice(0, 500)}...`
                : listingDetails?.listing_description}
              {listingDetails?.listing_description?.length > 500 && (
                <Typography
                  onClick={() => setShowWholeDesc(!showWholeDesc)}
                  component="span"
                  sx={{
                    color: "#307AFF",
                    fontSize: "15px",
                    fontWeight: "400",
                    cursor: "pointer",
                  }}
                >
                  {showWholeDesc ? `Read Less` : `Read More`}
                </Typography>
              )}
            </>
          ) : (
            <Skeleton
              variant="rectangular"
              sx={{
                height: "30px",
                width: "100%",
              }}
            />
          )}
        </Typography>

        {!loadingDetails && (
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              overflow: "auto",
            }}
          >
            {listing_type === 2 && (
              <>
                <CustomChip
                  label="Capacity"
                  val={`${listingFeatures.capacity} ${listingFeatures.capacity_unit}`}
                />
                <CustomChip
                  label={`Booking Type`}
                  val={approvalPolicy === 2 ? "Instabook" : "Manual"}
                />
                <CustomChip
                  label={`Service Offered`}
                  val={
                    listingFeatures.offer_delv_pickup ? "Delivery" : "Pickup"
                  }
                />
                <CustomChip
                  label={`Type`}
                  val={listingFeatures.attachment_type}
                />
              </>
            )}
            {listing_type === 1 && (
              <>
                <CustomChip label="HP" val={listingFeatures.horse_power} />

                <CustomChip
                  label={`Booking Type`}
                  val={approvalPolicy === 2 ? "Instabook" : "Manual"}
                />
                <CustomChip
                  label={`Service Offered`}
                  val={
                    listingFeatures.offer_delv_pickup ? "Delivery" : "Pickup"
                  }
                />
                <CustomChip
                  label={`Manufacturer`}
                  val={listingDetails?.manufacturer?.name}
                />
                <CustomChip
                  label={`Model`}
                  val={listingDetails?.manufacturer_model?.name}
                />
              </>
            )}
          </Box>
        )}
        {loadingDetails && (
          <Box display="flex" gap="10px">
            <Skeleton
              sx={{ height: "50px", borderRadius: "5rem", width: "200px" }}
              variant="rectangular"
            />
            <Skeleton
              sx={{ height: "50px", borderRadius: "5rem", width: "200px" }}
              variant="rectangular"
            />
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: {
            sm: "block",
            xs: "block",
            md: "none",
            lg: "none",
            xl: "none",
          },
          height: "8px",
          background: "#F7F7F7",
          width: "100%",
        }}
      />
      {!loadingDetails && <ListingFeatures />}
      {loadingDetails && (
        <Box display="flex" gap="10px" flexWrap="wrap" mt="10px" ml="2%">
          <Skeleton
            sx={{ height: "100px", borderRadius: "10px", width: "100px" }}
            variant="rectangular"
          />
          <Skeleton
            sx={{ height: "100px", borderRadius: "10px", width: "100px" }}
            variant="rectangular"
          />
          <Skeleton
            sx={{ height: "100px", borderRadius: "10px", width: "100px" }}
            variant="rectangular"
          />
          <Skeleton
            sx={{ height: "100px", borderRadius: "10px", width: "100px" }}
            variant="rectangular"
          />
        </Box>
      )}
      <Box
        sx={{
          display: {
            sm: "block",
            xs: "block",
            md: "none",
            lg: "none",
            xl: "none",
          },
          height: "8px",
          background: "#F7F7F7",
          width: "100%",
          mt: "20px",
        }}
      />

      {!loadingDetails && (
        <ChooseDeliverType
          delvType={delvType}
          onChange={setDelvType}
          userProvided={
            listingDetails?.user?.user_profile_configs?.[0]?.offer_delv_pickup
          }
        />
      )}
      <Box
        sx={{
          display: {
            sm: "block",
            xs: "block",
            md: "none",
            lg: "none",
            xl: "none",
          },
          height: "8px",
          background: "#F7F7F7",
          width: "100%",
          mt: "20px",
        }}
      />

      {!loadingDetails && <ListingOwner user={listingDetails?.user} />}
      {loadingDetails && (
        <Box display="flex" gap="10px" flexWrap="wrap" mt="10px" ml="2%">
          <Skeleton
            sx={{ height: "200px", borderRadius: "10px", width: "100%" }}
            variant="rectangular"
          />
        </Box>
      )}
      <Box
        sx={{
          display: {
            sm: "block",
            xs: "block",
            md: "none",
            lg: "none",
            xl: "none",
          },
          height: "8px",
          background: "#F7F7F7",
          width: "100%",
        }}
      />

      <RulesPolicyDoc />
      <Box
        sx={{
          display: {
            sm: "block",
            xs: "block",
            md: "none",
            lg: "none",
            xl: "none",
          },
          height: "8px",
          background: "#F7F7F7",
          width: "100%",
        }}
      />
      <Box
        sx={{
          mt: "40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",

          gap: "40px",
          px: { md: "2%", lg: "2%", xl: "2%", sm: "4%", xs: "4%" },
          py: "0px",
        }}
      >
        {!loadingDetails && (
          <Typography
            sx={{
              fontSize: "24px",
              fontWeight: 600,
              lineHeight: "31px",
              color: "#323232",
            }}
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              currencyDisplay: "narrowSymbol",
            }).format(listingDetails?.price)}
            /
            <Typography
              component="span"
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                lineHeight: "31px",
                color: "#323232",
              }}
            >
              Day
            </Typography>
          </Typography>
        )}

        <Button
          variant="contained"
          sx={{
            height: "56px",
            fontWeight: 500,
            fontSize: "15px",
            borderRadius: "10px",
          }}
          fullWidth
          disabled={
            cartReducer?.addingToCartId === listingDetails.id ||
            isAddedToCart ||
            listingDetails?.user?.firebase_id === getAuthUserId() ||
            loadingDetails
          }
          onClick={() =>
            checkAddToCartAllow({
              data: listingDetails,
              allItems: cartReducer?.items ?? [],
              callback: () => addTocart(),
              onError: (message: string) => {
                dispatch(
                  handleSnackBar({
                    message,
                    open: true,
                    severity: "error",
                  })
                );
              },
            })
          }
        >
          Add to Cart
        </Button>
      </Box>
    </Box>
  );
};

export default ListingDetails;
